export const getTaxonomyImportTemplateData = (): string[][] => [
  ['Level 1', 'Level 2', 'Level 3'],
  ['Compressors', 'Scroll compressor', ''],
  ['Compressors', 'Reciprocating compressor', 'Hermetic'],
  ['Compressors', 'Reciprocating compressor', 'Semi-hermetic'],
  ['Compressors', 'Reciprocating compressor', 'Open'],
  ['Compressors', 'Rotary compressor', ''],
  ['Vessels and Tanks', 'Cylindrical vessels', ''],
  ['Vessels and Tanks', 'Non-cylindrical vessels', ''],
  ['Insulation', 'Pipe insulation', ''],
  ['Insulation', 'Sheet insulation', ''],
];
